import React from 'react';
import MapEvent from './MapEvent';
import EventHeader from './EventHeader/EventHeader';
import Timer from './Timer/Timer';
import SplitTimes from './RightSidebar/SplitTimes';
import CompetitorSplitsPanel from './CompetitorSplitsPanel';
import MapSplitsContainer from './MapSplitsContainer';
import { SIDEBAR_WIDTH } from './layout';
import { Box, useMediaQuery, useTheme } from '@mui/material';

const EventComponent: React.FC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  const [open, setOpen] = React.useState(window.innerWidth >= 768);
  const [hiddenRouteIds, setHiddenRouteIds] = React.useState<number[]>([]);
  const shellRef = React.useRef<HTMLDivElement>(null);

  return (
    <Box className="event-shell" ref={shellRef}>
      <EventHeader shellRef={shellRef} hiddenRouteIds={hiddenRouteIds} setHiddenRouteIds={setHiddenRouteIds} />
      <Box
        component="main"
        sx={{ flex: '1 1 auto', minWidth: 0, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
      >
        <Box sx={{ flex: '1 1 auto', minHeight: 0, position: 'relative' }}>
          <MapEvent open={open} setOpen={setOpen} hiddenRouteIds={hiddenRouteIds} />
          <MapSplitsContainer
            sx={{
              top: '15px',
              fontSize: '11px',
              right: open ? `${SIDEBAR_WIDTH + 15}px` : '55px',
              maxWidth: `min(320px, calc(100vw - ${open ? SIDEBAR_WIDTH + 30 : 70}px))`
            }}
            defaultExpanded={isDesktop}
          >
            <SplitTimes all={false} />
          </MapSplitsContainer>
          <CompetitorSplitsPanel sidebarOpen={open} isDesktop={isDesktop} />
        </Box>
        <Timer />
      </Box>
    </Box>
  );
};

export default EventComponent;
